import LocalImages from "assets/images/local-images";
import Body from "features/shared/styles/typography/Body.styled";
import { FC, useState } from "react";

import BurgerMenuStyled from "./styles/BurgerMenu.styled";
import Menu from "./styles/Menu.styled";
import MenuButton from "./styles/MenuButton.styled";
// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
// See configuration in webpack.config.js
import MenuItem from "./styles/MenuItem-APP_CLIENT.styled";
import useHeaderLinks from "features/shared/hooks/navigation/useHeaderLinks";

const BurgerMenu: FC = () => {
  const [isOpen, openMenu] = useState(false);

  const links = useHeaderLinks(true);

  return (
    <BurgerMenuStyled>
      <MenuButton onClick={() => openMenu((isOpen) => !isOpen)}>
        <img
          alt="menu button"
          src={
            isOpen
              ? LocalImages.shared.images.icons.burgerMenuClose
              : LocalImages.shared.images.icons.burgerMenu
          }
        />
      </MenuButton>

      {isOpen ? (
        <Menu>
          {links.map((link, index) => {
            return (
              <MenuItem key={`menu-item-${index}`}>
                <a href={link.url}>
                  <Body>{link.title}</Body>
                </a>
              </MenuItem>
            );
          })}
        </Menu>
      ) : null}
    </BurgerMenuStyled>
  );
};

export default BurgerMenu;
